"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DettaglioListLottoDtoToJSON = exports.DettaglioListLottoDtoFromJSONTyped = exports.DettaglioListLottoDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function DettaglioListLottoDtoFromJSON(json) {
    return DettaglioListLottoDtoFromJSONTyped(json, false);
}
exports.DettaglioListLottoDtoFromJSON = DettaglioListLottoDtoFromJSON;
function DettaglioListLottoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'idLotto': !runtime_1.exists(json, 'idLotto') ? undefined : json['idLotto'],
        'nomeLotto': !runtime_1.exists(json, 'nomeLotto') ? undefined : json['nomeLotto'],
        'idStatoLotto': !runtime_1.exists(json, 'idStatoLotto') ? undefined : json['idStatoLotto'],
        'statoNome': !runtime_1.exists(json, 'statoNome') ? undefined : json['statoNome'],
        'matricolaOperatore': !runtime_1.exists(json, 'matricolaOperatore') ? undefined : json['matricolaOperatore'],
        'nominativoOperatore': !runtime_1.exists(json, 'nominativoOperatore') ? undefined : json['nominativoOperatore'],
        'filialeOperatore': !runtime_1.exists(json, 'filialeOperatore') ? undefined : json['filialeOperatore'],
        'tipoProfiloOperatore': !runtime_1.exists(json, 'tipoProfiloOperatore') ? undefined : json['tipoProfiloOperatore'],
        'dataInizioCampagna': !runtime_1.exists(json, 'dataInizioCampagna') ? undefined : (new Date(json['dataInizioCampagna'])),
        'dataFineCampagna': !runtime_1.exists(json, 'dataFineCampagna') ? undefined : (new Date(json['dataFineCampagna'])),
        'dataInserimento': !runtime_1.exists(json, 'dataInserimento') ? undefined : (new Date(json['dataInserimento'])),
    };
}
exports.DettaglioListLottoDtoFromJSONTyped = DettaglioListLottoDtoFromJSONTyped;
function DettaglioListLottoDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'idLotto': value.idLotto,
        'nomeLotto': value.nomeLotto,
        'idStatoLotto': value.idStatoLotto,
        'statoNome': value.statoNome,
        'matricolaOperatore': value.matricolaOperatore,
        'nominativoOperatore': value.nominativoOperatore,
        'filialeOperatore': value.filialeOperatore,
        'tipoProfiloOperatore': value.tipoProfiloOperatore,
        'dataInizioCampagna': value.dataInizioCampagna === undefined ? undefined : (value.dataInizioCampagna.toISOString()),
        'dataFineCampagna': value.dataFineCampagna === undefined ? undefined : (value.dataFineCampagna.toISOString()),
        'dataInserimento': value.dataInserimento === undefined ? undefined : (value.dataInserimento.toISOString()),
    };
}
exports.DettaglioListLottoDtoToJSON = DettaglioListLottoDtoToJSON;
